import { createClient } from "@supabase/supabase-js";

// Live bindings: populated by initSupabase() from build-time env or runtime /api/auth/config.
export let supabase = null;
export let supabaseConfigured = false;
let initPromise = null;

function connect(url, key) {
  supabase = createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } });
  supabaseConfigured = true;
}

export function initSupabase() {
  if (initPromise) return initPromise;
  initPromise = (async () => {
    const buildUrl = process.env.REACT_APP_SUPABASE_URL;
    const buildKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
    if (buildUrl && buildKey) { connect(buildUrl, buildKey); return; }
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/config`, { cache: "no-store" });
    if (!response.ok) throw new Error("Could not load sign-in settings. Please refresh the page.");
    const config = await response.json();
    if (config.configured && config.supabase_url && config.supabase_anon_key) connect(config.supabase_url, config.supabase_anon_key);
  })().catch((error) => { initPromise = null; throw error; });
  return initPromise;
}
